import { Koi } from '@ksyos/koi';

export const moodSchema = Koi.number().min(1).max(9);
export const scoreSchema = Koi.number().min(0).max(100);
export const totalWeightLossSchema = Koi.number().min(-100).max(100);
